import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { environment } from 'src/environments/environment';
import { clearLocalStorageExceptCharts } from '../_helpers/window.helper';


@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {
  User: any;
  DefaultAvatarLink: any;
  display: boolean = false;
  StorageData: any = []

  items!: MenuItem[];
  settingstatus: boolean = false
  usersettingstatus: boolean = false
  overallstatus: boolean = true
  version = environment.appVersion;
  headerClass: { [key: string]: boolean };
  hideModules: any = [];
  isAdmin: boolean = false;

  //hullcalcultor

  avgFullHullCleaningCost: any; //B12
  avgPropellerPolishingCost: any; //b14
  avgBunkerPrice: any; //b16
  avgDailyConsumption: any;//b18
  savings: any;//b20
  dailyHireDay: any//b22
  timeRequiredforCleaning: any;//b24

  paybackPeriod: any;
  visiblePopup: boolean = false
  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  @ViewChild('opSettings') opSettings!: OverlayPanel;

  constructor(public layoutService: LayoutService, private router: Router) {
    var Data = localStorage.getItem('currentUser')
    const currentUserData = JSON.parse(Data ? Data : "");
    this.User = currentUserData.user;
    this.StorageData = (currentUserData.modules);

    var menuModulesWithModuleId = currentUserData.user.userRoles[0].role.roleModuleMenuMapping;
    var moduleMenus = currentUserData.moduleMenus;

    if (currentUserData.user.userRoles[0].role.roleName === 'Administrator') { this.isAdmin = true; }


    if (menuModulesWithModuleId === null || menuModulesWithModuleId === undefined) {
      // Exiting roles
    }
    else if (menuModulesWithModuleId.length > 0) {  // Saved for new roles
      // New Roles

      menuModulesWithModuleId.forEach((item: any) => {
        if (item.policyId === 4 && item.moduleMenuId !== 0)  // If Item policy Id is 4 then
        {
          // find module name
          var moduleName = moduleMenus.find((x: any) => x.moduleMenuId === item.moduleMenuId);
          if (moduleName !== undefined) {
            this.hideModules.push(moduleName.menuName);
          }
        }
      });
    }
    console.log(this.hideModules);
    if ((this.StorageData.some((x: any) => x.moduleName === 'Settings'))) {
      this.settingstatus = true
    };
    if ((this.StorageData.some((x: any) => x.moduleName === 'UserSettings'))) {
      this.usersettingstatus = true
    };
    if (this.settingstatus == false && this.usersettingstatus == false) {
      this.overallstatus = false
    }

    let principalId = this.User.principalId;
    // Commenting below section to check principalType
    //let principalType = this.User.PrincipalType;
    this.headerClass = {};

    if (environment.headerClass) {
      this.headerClass[environment.headerClass] = true;
    }

    this.DefaultAvatarLink = "https://ui-avatars.com/api/?size=40&name=" + this.User?.firstName
  }
  logout(): void {
    clearLocalStorageExceptCharts();
    this.router.navigateByUrl('/auth/logout');
  }
  onClose() {

  }
  showCalculatorPop() {

    this.visiblePopup = true


  }

  calculate() {
    if (this.avgFullHullCleaningCost == 0) {
      this.paybackPeriod =
        (this.avgPropellerPolishingCost + (this.dailyHireDay * (this.timeRequiredforCleaning / 24))) / ((this.avgDailyConsumption * this.savings) * 0.25 * this.avgBunkerPrice)
    } else if (this.avgPropellerPolishingCost == 0) {
      this.paybackPeriod =
        (this.avgFullHullCleaningCost + (this.dailyHireDay * (this.timeRequiredforCleaning / 24))) / ((this.avgDailyConsumption * this.savings) * this.avgBunkerPrice)
    } else {
      this.paybackPeriod =
        ((this.avgFullHullCleaningCost + this.avgPropellerPolishingCost + (this.dailyHireDay * (this.timeRequiredforCleaning / 24)))) / ((this.avgDailyConsumption * this.savings) * this.avgBunkerPrice)
    }

    if (isNaN(this.paybackPeriod) || !isFinite(this.paybackPeriod)) {
      this.paybackPeriod = "00000";
    } else {
      this.paybackPeriod = this.paybackPeriod.toFixed(2);
    }

  }


  navigateToChangePassword() {
    this.router.navigate(['pages/change-password']);
  }

  closeOverlay() {
    this.opSettings.hide();
  }
}
